import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';
import { companyData } from '../../data/mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1621723927351-befd5e3055c2?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/90 via-slate-800/85 to-teal-900/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-600/20 border border-teal-500/30 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 bg-teal-400 rounded-full animate-pulse" />
            <span className="text-teal-300 text-sm font-medium">
              {companyData.experience} Erfahrung
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            <span className="text-teal-400">ADMIN</span> Hausverwaltung
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 font-medium mb-4">
            {companyData.tagline}
          </p>

          <p className="text-lg text-white/70 max-w-2xl mx-auto mb-10">
            {companyData.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-base font-semibold rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-teal-600/25"
              onClick={() => scrollToSection('#contact')}
            >
              Jetzt Kontakt aufnehmen
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-base font-semibold rounded-full transition-all duration-300"
              onClick={() => scrollToSection('#services')}
            >
              Leistungen ansehen
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
          <button
            onClick={() => scrollToSection('#about')}
            className="flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors"
            aria-label="Scroll down"
          >
            <span className="text-sm">Mehr erfahren</span>
            <ChevronDown className="w-6 h-6 animate-bounce" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
